

export const translations: Record<string, Record<string, string>> = {
  en: {
    // Nav & General
    "nav_home": "Home",
    "nav_my_church": "My Church",
    "nav_events": "Events",
    "nav_volunteer": "Volunteer",
    "nav_messaging": "Messaging",
    "nav_notifications": "Notifications",
    "nav_profile": "Profile",
    "nav_settings": "Settings",
    "nav_sign_out": "Sign Out",
    "nav_guide": "User Guide",
    "search_placeholder": "Search...",
    "search_people": "Search people...",
    "loading": "Loading...",
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "post": "Post",
    "posting": "Posting...",
    "processing": "Processing...",
    
    // Auth / Landing
    "auth_sign_in": "Sign In",
    "auth_sign_up": "Sign Up",
    "auth_email": "Email",
    "auth_password": "Password",
    "auth_or": "Or continue with",
    "auth_have_account": "Already have an account? Sign In",
    "auth_no_account": "Don't have an account? Sign Up",
    "auth_check_email": "Check your email for the confirmation link!",
    "landing_title_1": "United in",
    "landing_title_2": "Faith",
    "landing_title_3": "Connected in",
    "landing_title_4": "Spirit",
    "landing_subtitle": "Join a global community of believers. Share your journey, find your church family, and grow together in Christ.",
    "landing_copyright": "All glory to God.",
    "landing_verse_text": "For I know the plans I have for you, declares the Lord, plans to prosper you and not to harm you, plans to give you hope and a future.",
    "landing_verse_ref": "Jeremiah 29:11",
    "get_started": "Get Started",
    "register_ministry": "Register Ministry",
    "for_churches": "For Churches",
    "seo_title": "Holyness - United in Faith",
    "seo_description": "Connect with believers worldwide, join church communities, and grow in your faith journey.",

    // Feed
    "feed_placeholder": "Share a word, testimony, or prayer request...",
    "feed_photo": "Photo",
    "feed_video": "Video",
    "feed_cite": "Cite Bible",
    "feed_emojis": "Emojis",
    "daily_bread": "Daily Bread",
    "share_verse": "Share Verse",
    "suggestions": "Suggestions",
    "likes": "Likes",
    "comments": "Comments",
    "share": "Share",
    "write_comment": "Write a comment...",

    // Church Page
    "church_members": "Members",
    "church_give": "Give / Tithe",
    "church_admin": "Church Admin",
    "tab_home": "Home",
    "tab_sermons": "Sermons",
    "tab_events": "Events",
    "tab_cells": "Cells",
    "tab_causes": "Causes",
    "tab_give": "Give",
    "tab_admin": "Admin Tools",
    "worship_songs": "Worship Songs",
    "community_impact": "Community Impact",
    "sermon_no_video": "No Video Available",
    "add_video": "Add Video",
    "post_sermon": "Post New Sermon",
    "upcoming_gatherings": "Upcoming Gatherings",
    "prayer_cells": "Prayer Cells & Small Groups",
    "join_group": "Join Group",
    "leave_group": "Leave",
    "create_cell": "Create Cell",
    "support_ministry": "Support Our Ministry",
    "give_securely": "Give Online Securely",

    // Events
    "kingdom_gatherings": "Kingdom Gatherings",
    "discover_events": "Discover events and unite with the body of Christ.",
    "host_gathering": "Host Gathering",
    "rsvp_now": "RSVP Now",
    "register_pay": "Register & Pay",
    "free": "Free",
    "guest_speakers": "Guest Speakers",
    "hosted_by": "Hosted by",

    // Volunteering
    "acts_of_service": "Acts of Service",
    "i_need_help": "I Need Help",
    "i_want_help": "I Want to Help",
    "community_board": "Community Board",
    "urgent": "URGENT",
    "contact_info": "Contact Info",
    "connect": "Connect",
    "create_request": "Create Help Request",
    "create_offer": "Offer Help / Service",

    // Settings
    "settings_title": "Settings & Preferences",
    "account_security": "Account Security",
    "change_password": "Change Password",
    "faith_prefs": "Faith Preferences",
    "pref_bible_version": "Preferred Bible Version",
    "application": "Application",
    "language": "Language",
    "enable_notifications": "Notifications",
    "save_prefs": "Save Preferences",

    // Contact
    "contact_title": "Contact Us",
    "contact_subtitle": "Your feedback helps us grow and serve the Kingdom better.",
    "rate_experience": "Rate your experience",
    "opinion_label": "What can we improve?",
    "opinion_placeholder": "Share your thoughts, suggestions, or report an issue...",
    "submit_feedback": "Send Feedback",
    "feedback_success": "Thank you! Your feedback has been sent.",
    "feedback_error": "Failed to send feedback. Please try again.",

    // User Guide
    "guide_title": "User Guide",
    "guide_subtitle": "Learn how to make the most of Holyness features.",
    "guide_video_tour": "App Video Tour",
    "guide_video_desc": "Watch this quick overview to learn how to navigate and use the main features of Holyness.",
    "guide_role_member": "Member",
    "guide_role_pastor": "Pastor",
    "guide_role_church": "Church",
    "guide_role_admin": "Admin",
    "guide_member_desc": "Connect with friends, share your journey, find churches, attend events, and volunteer for community causes.",
    "guide_pastor_desc": "Manage your church page, create sermons using the Bible, organize events, and oversee your congregation members.",
    "guide_church_desc": "Register your ministry to reach a global audience, receive tithes, and manage church operations.",
    "guide_admin_desc": "Tools for managing users, roles, and content safety within your church organization.",

    // Guide Slides
    "guide_feat_feed": "Feed",
    "guide_feat_feed_desc": "Post updates, photos, and videos. Cite Bible verses directly.",
    "guide_feat_events": "Events",
    "guide_feat_events_desc": "Browse map or list to find worship nights and gatherings.",
    "guide_feat_volunteering": "Volunteering",
    "guide_feat_volunteering_desc": "Request help or offer services in the Community Board.",
    "guide_feat_profile": "Profile",
    "guide_feat_profile_desc": "Customize your bio, banner, and connect with other believers.",
    "guide_feat_sermon": "Sermon Builder",
    "guide_feat_sermon_desc": "Use the rich-text editor with the Bible assistance to write and save sermons.",
    "guide_feat_events_church": "Church Events",
    "guide_feat_events_church_desc": "Create official church events that appear on the global map.",
    "guide_feat_team": "Team",
    "guide_feat_team_desc": "Assign roles to other staff members.",
    "guide_feat_registration": "Registration",
    "guide_feat_registration_desc": "Create a verified page for your ministry.",
    "guide_feat_donations": "Donations",
    "guide_feat_donations_desc": "Securely receive tithes via Stripe integration.",
    "guide_feat_causes": "Causes",
    "guide_feat_causes_desc": "Post community needs (food drives, housing) to rally support.",
    "guide_feat_user_mgmt": "User Management",
    "guide_feat_user_mgmt_desc": "Add or remove members from your church roster.",
    "guide_feat_safety": "Content Safety",
    "guide_feat_safety_desc": "AI automatically flags inappropriate content.",
    "guide_feat_settings": "Settings",
    "guide_feat_settings_desc": "Manage church details, worship songs, and banners."
  },
  es: {
    "nav_home": "Inicio",
    "nav_my_church": "Mi Iglesia",
    "nav_events": "Eventos",
    "nav_volunteer": "Voluntariado",
    "nav_messaging": "Mensajes",
    "nav_notifications": "Notificaciones",
    "nav_profile": "Perfil",
    "nav_settings": "Ajustes",
    "nav_sign_out": "Cerrar Sesión",
    "nav_guide": "Guía de Usuario",
    "search_placeholder": "Buscar...",
    "search_people": "Buscar personas...",
    "loading": "Cargando...",
    "save": "Guardar",
    "cancel": "Cancelar",
    "delete": "Eliminar",
    "edit": "Editar",
    "post": "Publicar",
    "posting": "Publicando...",
    "processing": "Procesando...",
    "auth_sign_in": "Iniciar Sesión",
    "auth_sign_up": "Registrarse",
    "auth_email": "Correo",
    "auth_password": "Contraseña",
    "auth_or": "O continúa con",
    "auth_have_account": "¿Ya tienes una cuenta? Iniciar Sesión",
    "auth_no_account": "¿No tienes cuenta? Regístrate",
    "auth_check_email": "¡Revisa tu correo para el enlace de confirmación!",
    "landing_title_1": "Unidos en",
    "landing_title_2": "Fe",
    "landing_title_3": "Conectados en",
    "landing_title_4": "Espíritu",
    "landing_subtitle": "Únete a una comunidad global de creyentes. Comparte tu camino, encuentra tu familia eclesial y crece en Cristo.",
    "landing_copyright": "Toda la gloria a Dios.",
    "landing_verse_text": "Porque yo sé muy bien los planes que tengo para ustedes —afirma el Señor—, planes de bienestar y no de calamidad, a fin de darles un futuro y una esperanza.",
    "landing_verse_ref": "Jeremías 29:11",
    "get_started": "Comenzar",
    "register_ministry": "Registrar Ministerio",
    "for_churches": "Para Iglesias",
    "seo_title": "Holyness - Unidos en la Fe",
    "seo_description": "Conéctate con creyentes de todo el mundo, únete a comunidades eclesiales y crece en tu camino de fe.",
    "feed_placeholder": "Comparte una palabra, testimonio o petición de oración...",
    "feed_photo": "Foto",
    "feed_video": "Video",
    "feed_cite": "Citar Biblia",
    "feed_emojis": "Emojis",
    "daily_bread": "Pan Diario",
    "share_verse": "Compartir Verso",
    "suggestions": "Sugerencias",
    "likes": "Me gusta",
    "comments": "Comentarios",
    "share": "Compartir",
    "write_comment": "Escribe un comentario...",
    "church_members": "Miembros",
    "church_give": "Dar / Diezmar",
    "church_admin": "Admin Iglesia",
    "tab_home": "Inicio",
    "tab_sermons": "Sermones",
    "tab_events": "Eventos",
    "tab_cells": "Células",
    "tab_causes": "Causas",
    "tab_give": "Dar",
    "tab_admin": "Herramientas Admin",
    "worship_songs": "Canciones de Adoración",
    "community_impact": "Impacto Comunitario",
    "sermon_no_video": "Video No Disponible",
    "add_video": "Agregar Video",
    "post_sermon": "Publicar Sermón",
    "upcoming_gatherings": "Próximas Reuniones",
    "prayer_cells": "Células de Oración y Grupos Pequeños",
    "join_group": "Unirse",
    "leave_group": "Salir",
    "create_cell": "Crear Célula",
    "support_ministry": "Apoya Nuestro Ministerio",
    "give_securely": "Dar en Línea Segura",
    "kingdom_gatherings": "Reuniones del Reino",
    "discover_events": "Descubre eventos y únete al cuerpo de Cristo.",
    "host_gathering": "Organizar Reunión",
    "rsvp_now": "Reservar Ahora",
    "register_pay": "Registrar y Pagar",
    "free": "Gratis",
    "guest_speakers": "Oradores Invitados",
    "hosted_by": "Organizado por",
    "acts_of_service": "Actos de Servicio",
    "i_need_help": "Necesito Ayuda",
    "i_want_help": "Quiero Ayudar",
    "community_board": "Tablero Comunitario",
    "urgent": "URGENTE",
    "contact_info": "Contacto",
    "connect": "Conectar",
    "create_request": "Crear Solicitud de Ayuda",
    "create_offer": "Ofrecer Ayuda / Servicio",
    "settings_title": "Ajustes y Preferencias",
    "account_security": "Seguridad de la Cuenta",
    "change_password": "Cambiar Contraseña",
    "faith_prefs": "Preferencias de Fe",
    "pref_bible_version": "Versión de Biblia Preferida",
    "application": "Aplicación",
    "language": "Idioma",
    "enable_notifications": "Notificaciones",
    "save_prefs": "Guardar Preferencias",
    "contact_title": "Contáctanos",
    "contact_subtitle": "Tus comentarios nos ayudan a crecer y servir mejor al Reino.",
    "rate_experience": "Califica tu experiencia",
    "opinion_label": "¿Qué podemos mejorar?",
    "opinion_placeholder": "Comparte tus pensamientos, sugerencias o reporta un problema...",
    "submit_feedback": "Enviar Comentarios",
    "feedback_success": "¡Gracias! Tus comentarios han sido enviados.",
    "feedback_error": "Error al enviar comentarios. Intenta de nuevo.",
    "guide_title": "Guía de Usuario",
    "guide_subtitle": "Aprende a aprovechar al máximo las funciones de Holyness.",
    "guide_video_tour": "Recorrido en Video de la App",
    "guide_video_desc": "Mira este resumen rápido para aprender a navegar y utilizar las características principales de Holyness.",
    "guide_role_member": "Miembro",
    "guide_role_pastor": "Pastor",
    "guide_role_church": "Iglesia",
    "guide_role_admin": "Admin",
    "guide_member_desc": "Conéctate con amigos, comparte tu camino de fe, encuentra iglesias, asiste a eventos y sé voluntario en causas comunitarias.",
    "guide_pastor_desc": "Administra la página de tu iglesia, crea sermones con la Biblia, organiza eventos y supervisa a los miembros de tu congregación.",
    "guide_church_desc": "Registra tu ministerio para llegar a una audiencia global, recibir diezmos y gestionar operaciones de la iglesia.",
    "guide_admin_desc": "Herramientas para gestionar usuarios, roles y seguridad del contenido dentro de tu organización eclesial.",
    "guide_feat_feed": "Muro",
    "guide_feat_feed_desc": "Publica actualizaciones, fotos y videos. Cita versículos de la Biblia directamente.",
    "guide_feat_events": "Eventos",
    "guide_feat_events_desc": "Explora el mapa o la lista para encontrar noches de adoración y reuniones.",
    "guide_feat_volunteering": "Voluntariado",
    "guide_feat_volunteering_desc": "Solicita ayuda u ofrece servicios en el Tablero Comunitario.",
    "guide_feat_profile": "Perfil",
    "guide_feat_profile_desc": "Personaliza tu biografía, banner y conéctate con otros creyentes.",
    "guide_feat_sermon": "Constructor de Sermones",
    "guide_feat_sermon_desc": "Utiliza el editor de texto enriquecido con asistencia de la Biblia para escribir y guardar sermones.",
    "guide_feat_events_church": "Eventos de la Iglesia",
    "guide_feat_events_church_desc": "Crea eventos oficiales de la iglesia que aparecen en el mapa global.",
    "guide_feat_team": "Equipo",
    "guide_feat_team_desc": "Asigna roles a otros miembros del personal.",
    "guide_feat_registration": "Registro",
    "guide_feat_registration_desc": "Crea una página verificada para tu ministerio.",
    "guide_feat_donations": "Donaciones",
    "guide_feat_donations_desc": "Recibe diezmos de forma segura a través de la integración con Stripe.",
    "guide_feat_causes": "Causas",
    "guide_feat_causes_desc": "Publica necesidades comunitarias (colectas de alimentos, vivienda) para conseguir apoyo.",
    "guide_feat_user_mgmt": "Gestión de Usuarios",
    "guide_feat_user_mgmt_desc": "Agrega o elimina miembros de la lista de tu iglesia.",
    "guide_feat_safety": "Seguridad de Contenido",
    "guide_feat_safety_desc": "La IA marca automáticamente el contenido inapropiado.",
    "guide_feat_settings": "Ajustes",
    "guide_feat_settings_desc": "Administra los detalles de la iglesia, canciones de adoración y banners."
  },
  pt: {
    "nav_home": "Início",
    "nav_my_church": "Minha Igreja",
    "nav_events": "Eventos",
    "nav_volunteer": "Voluntariado",
    "nav_messaging": "Mensagens",
    "nav_notifications": "Notificações",
    "nav_profile": "Perfil",
    "nav_settings": "Configurações",
    "nav_sign_out": "Sair",
    "nav_guide": "Guia do Usuário",
    "search_placeholder": "Pesquisar...",
    "search_people": "Procurar pessoas...",
    "loading": "Carregando...",
    "save": "Salvar",
    "cancel": "Cancelar",
    "delete": "Excluir",
    "edit": "Editar",
    "post": "Publicar",
    "posting": "Publicando...",
    "processing": "Processando...",
    "auth_sign_in": "Entrar",
    "auth_sign_up": "Cadastrar",
    "auth_email": "Email",
    "auth_password": "Senha",
    "auth_or": "Ou continue com",
    "auth_have_account": "Já tem uma conta? Entrar",
    "auth_no_account": "Não tem uma conta? Cadastre-se",
    "auth_check_email": "Verifique seu e-mail para o link de confirmação!",
    "landing_title_1": "Unidos na",
    "landing_title_2": "Fé",
    "landing_title_3": "Conectados no",
    "landing_title_4": "Espírito",
    "landing_subtitle": "Junte-se a uma comunidade global de crentes. Compartilhe sua jornada, encontre sua família na igreja e cresça em Cristo.",
    "landing_copyright": "Toda a glória a Deus.",
    "landing_verse_text": "Porque sou eu que conheço os planos que tenho para vocês', diz o Senhor, 'planos de fazê-los prosperar e não de causar dano, planos de dar-lhes esperança e um futuro.",
    "landing_verse_ref": "Jeremias 29:11",
    "get_started": "Começar",
    "register_ministry": "Registrar Ministério",
    "for_churches": "Para Igrejas",
    "seo_title": "Holyness - Unidos na Fé",
    "seo_description": "Conecte-se com crentes em todo o mundo, junte-se a comunidades de igrejas e cresça em sua jornada de fé.",
    "feed_placeholder": "Compartilhe uma palavra, testemunho ou pedido de oração...",
    "feed_photo": "Foto",
    "feed_video": "Vídeo",
    "feed_cite": "Citar Bíblia",
    "feed_emojis": "Emojis",
    "daily_bread": "Pão Diário",
    "share_verse": "Compartilhar Versículo",
    "suggestions": "Sugestões",
    "likes": "Curtidas",
    "comments": "Comentários",
    "share": "Compartilhar",
    "write_comment": "Escreva um comentário...",
    "church_members": "Membros",
    "church_give": "Doar / Dizimar",
    "church_admin": "Admin da Igreja",
    "tab_home": "Início",
    "tab_sermons": "Sermões",
    "tab_events": "Eventos",
    "tab_cells": "Células",
    "tab_causes": "Causas",
    "tab_give": "Doar",
    "tab_admin": "Ferramentas Admin",
    "worship_songs": "Louvores",
    "community_impact": "Impacto Comunitário",
    "sermon_no_video": "Vídeo Indisponível",
    "add_video": "Adicionar Vídeo",
    "post_sermon": "Postar Novo Sermão",
    "upcoming_gatherings": "Próximas Reuniões",
    "prayer_cells": "Células de Oração e Pequenos Grupos",
    "join_group": "Participar",
    "leave_group": "Sair",
    "create_cell": "Criar Célula",
    "support_ministry": "Apoie Nosso Ministério",
    "give_securely": "Doar Online com Segurança",
    "kingdom_gatherings": "Reuniões do Reino",
    "discover_events": "Descubra eventos e una-se ao corpo de Cristo.",
    "host_gathering": "Organizar Reunião",
    "rsvp_now": "Confirmar Presença",
    "register_pay": "Registrar e Pagar",
    "free": "Grátis",
    "guest_speakers": "Oradores Convidados",
    "hosted_by": "Organizado por",
    "acts_of_service": "Atos de Serviço",
    "i_need_help": "Preciso de Ajuda",
    "i_want_help": "Quero Ajudar",
    "community_board": "Quadro Comunitário",
    "urgent": "URGENTE",
    "contact_info": "Contato",
    "connect": "Conectar",
    "create_request": "Criar Pedido de Ajuda",
    "create_offer": "Oferecer Ajuda / Serviço",
    "settings_title": "Configurações e Preferências",
    "account_security": "Segurança da Conta",
    "change_password": "Alterar Senha",
    "faith_prefs": "Preferências de Fé",
    "pref_bible_version": "Versão da Bíblia Preferida",
    "application": "Aplicação",
    "language": "Idioma",
    "enable_notifications": "Notificações",
    "save_prefs": "Salvar Preferências",
    "contact_title": "Fale Conosco",
    "contact_subtitle": "Seu feedback nos ajuda a crescer e servir melhor ao Reino.",
    "rate_experience": "Avalie sua experiência",
    "opinion_label": "O que podemos melhorar?",
    "opinion_placeholder": "Compartilhe seus pensamentos, sugestões ou relate um problema...",
    "submit_feedback": "Enviar Feedback",
    "feedback_success": "Obrigado! Seu feedback foi enviado.",
    "feedback_error": "Falha ao enviar feedback. Tente novamente.",
    "guide_title": "Guia do Usuário",
    "guide_subtitle": "Aprenda como aproveitar ao máximo os recursos do Holyness.",
    "guide_video_tour": "Tour de Vídeo do App",
    "guide_video_desc": "Assista a esta visão geral rápida para aprender a navegar e usar os principais recursos do Holyness.",
    "guide_role_member": "Membro",
    "guide_role_pastor": "Pastor",
    "guide_role_church": "Igreja",
    "guide_role_admin": "Admin",
    "guide_member_desc": "Conecte-se com amigos, compartilhe sua jornada de fé, encontre igrejas, participe de eventos e seja voluntário em causas comunitárias.",
    "guide_pastor_desc": "Gerencie a página da sua igreja, crie sermões usando a Bíblia, organize eventos e supervisione os membros da sua congregação.",
    "guide_church_desc": "Registre seu ministério para alcançar um público global, receber dízimos e gerenciar as operações da igreja.",
    "guide_admin_desc": "Ferramentas para gerenciar usuários, funções e segurança de conteúdo dentro da sua organização eclesiástica.",
    "guide_feat_feed": "Feed",
    "guide_feat_feed_desc": "Publique atualizações, fotos e vídeos. Cite versículos da Bíblia diretamente.",
    "guide_feat_events": "Eventos",
    "guide_feat_events_desc": "Navegue pelo mapa ou lista para encontrar noites de adoração e reuniões.",
    "guide_feat_volunteering": "Voluntariado",
    "guide_feat_volunteering_desc": "Solicite ajuda ou ofereça serviços no Quadro Comunitário.",
    "guide_feat_profile": "Perfil",
    "guide_feat_profile_desc": "Personalize sua biografia, banner e conecte-se com outros crentes.",
    "guide_feat_sermon": "Construtor de Sermões",
    "guide_feat_sermon_desc": "Use o editor de texto rico com assistência da Bíblia para escrever e salvar sermões.",
    "guide_feat_events_church": "Eventos da Igreja",
    "guide_feat_events_church_desc": "Crie eventos oficiais da igreja que aparecem no mapa global.",
    "guide_feat_team": "Equipe",
    "guide_feat_team_desc": "Atribua funções a outros membros da equipe.",
    "guide_feat_registration": "Registro",
    "guide_feat_registration_desc": "Crie uma página verificada para o seu ministério.",
    "guide_feat_donations": "Doações",
    "guide_feat_donations_desc": "Receba dízimos com segurança via integração com Stripe.",
    "guide_feat_causes": "Causas",
    "guide_feat_causes_desc": "Publique necessidades comunitarias (coletas de alimentos, moradia) para reunir apoio.",
    "guide_feat_user_mgmt": "Gestão de Usuários",
    "guide_feat_user_mgmt_desc": "Adicione ou remova membros da lista da sua igreja.",
    "guide_feat_safety": "Segurança de Conteúdo",
    "guide_feat_safety_desc": "A IA sinaliza automaticamente conteúdo inadequado.",
    "guide_feat_settings": "Configurações",
    "guide_feat_settings_desc": "Gerencie detalhes da igreja, louvores e banners."
  },
  fr: {
    "nav_home": "Accueil",
    "nav_my_church": "Mon Église",
    "nav_events": "Événements",
    "nav_volunteer": "Bénévolat",
    "nav_messaging": "Messagerie",
    "nav_notifications": "Notifications",
    "nav_profile": "Perfil",
    "nav_settings": "Paramètres",
    "nav_sign_out": "Déconnexion",
    "nav_guide": "Guide de l'Utilisateur",
    "search_placeholder": "Rechercher...",
    "search_people": "Rechercher des personnes...",
    "loading": "Chargement...",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "delete": "Supprimer",
    "edit": "Modifier",
    "post": "Publier",
    "posting": "Publication...",
    "processing": "Traitement...",
    "auth_sign_in": "Se connecter",
    "auth_sign_up": "S'inscrire",
    "auth_email": "Email",
    "auth_password": "Mot de passe",
    "auth_or": "Ou continuer avec",
    "auth_have_account": "Vous avez déjà un compte ? Se connecter",
    "auth_no_account": "Pas de compte ? S'inscrire",
    "auth_check_email": "Vérifiez votre email pour le lien de confirmation !",
    "landing_title_1": "Unis dans la",
    "landing_title_2": "Foi",
    "landing_title_3": "Connectés en",
    "landing_title_4": "Esprit",
    "landing_subtitle": "Rejoignez une communauté mondiale de croyants. Partagez votre parcours, trouvez votre famille d'église et grandissez en Christ.",
    "landing_copyright": "Toute la gloire à Dieu.",
    "landing_verse_text": "Car je connais les projets que j'ai formés sur vous, dit l'Éternel, projets de paix et non de malheur, afin de vous donner un avenir et de l'espérance.",
    "landing_verse_ref": "Jérémie 29:11",
    "get_started": "Commencer",
    "register_ministry": "Enregistrer le Ministère",
    "for_churches": "Pour les Églises",
    "seo_title": "Holyness - Unis dans la Foi",
    "seo_description": "Connectez-vous avec des croyants du monde entier, rejoignez des communautés ecclésiales et grandissez dans votre cheminement de foi.",
    "feed_placeholder": "Partagez une parole, un témoignage ou une requête de prière...",
    "feed_photo": "Photo",
    "feed_video": "Vidéo",
    "feed_cite": "Citer la Bible",
    "feed_emojis": "Emojis",
    "daily_bread": "Pain Quotidien",
    "share_verse": "Partager le Verset",
    "suggestions": "Suggestions",
    "likes": "J'aime",
    "comments": "Commentaires",
    "share": "Partager",
    "write_comment": "Écrire un commentaire...",
    "church_members": "Membres",
    "church_give": "Donner / Dîmer",
    "church_admin": "Admin Église",
    "tab_home": "Accueil",
    "tab_sermons": "Sermons",
    "tab_events": "Événements",
    "tab_cells": "Cellules",
    "tab_causes": "Causes",
    "tab_give": "Donner",
    "tab_admin": "Outils Admin",
    "worship_songs": "Chants de Louange",
    "community_impact": "Impact Communautaire",
    "sermon_no_video": "Vidéo Non Disponible",
    "add_video": "Ajouter Vidéo",
    "post_sermon": "Publier Nouveau Sermon",
    "upcoming_gatherings": "Rassemblements à Venir",
    "prayer_cells": "Cellules de Prière & Petits Groupes",
    "join_group": "Rejoindre",
    "leave_group": "Quitter",
    "create_cell": "Créer Cellule",
    "support_ministry": "Soutenez Notre Ministère",
    "give_securely": "Donner en Ligne en Sécurité",
    "kingdom_gatherings": "Rassemblements du Royaume",
    "discover_events": "Découvrez des événements et unissez-vous au corps du Christ.",
    "host_gathering": "Organiser Rassemblement",
    "rsvp_now": "Réserver",
    "register_pay": "S'inscrire & Payer",
    "free": "Gratuit",
    "guest_speakers": "Invités",
    "hosted_by": "Organisé par",
    "acts_of_service": "Actes de Service",
    "i_need_help": "J'ai besoin d'aide",
    "i_want_help": "Je veux aider",
    "community_board": "Tableau Communautaire",
    "urgent": "URGENT",
    "contact_info": "Contact",
    "connect": "Connecter",
    "create_request": "Créer Demande d'Aide",
    "create_offer": "Offrir Aide / Service",
    "settings_title": "Paramètres et Préférences",
    "account_security": "Sécurité du Compte",
    "change_password": "Changer Mot de Passe",
    "faith_prefs": "Préférences de Foi",
    "pref_bible_version": "Version de Bible Préférée",
    "application": "Application",
    "language": "Langue",
    "enable_notifications": "Notifications",
    "save_prefs": "Enregistrer Préférences",
    "contact_title": "Contactez-nous",
    "contact_subtitle": "Vos commentaires nous aident à grandir et à mieux servir le Royaume.",
    "rate_experience": "Notez votre expérience",
    "opinion_label": "Que pouvons-nous améliorer ?",
    "opinion_placeholder": "Partagez vos pensées, suggestions ou signalez un problème...",
    "submit_feedback": "Envoyer",
    "feedback_success": "Merci ! Vos commentaires ont été envoyés.",
    "feedback_error": "Échec de l'envoi. Veuillez réessayer.",
    "guide_title": "Guide de l'Utilisateur",
    "guide_subtitle": "Apprenez à tirer le meilleur parti des fonctionnalités de Holyness.",
    "guide_video_tour": "Visite Vidéo de l'App",
    "guide_video_desc": "Regardez cet aperçu rapide pour apprendre à naviguer et à utiliser les principales fonctionnalités de Holyness.",
    "guide_role_member": "Membre",
    "guide_role_pastor": "Pasteur",
    "guide_role_church": "Église",
    "guide_role_admin": "Admin",
    "guide_member_desc": "Connectez-vous avec des amis, partagez votre cheminement de foi, trouvez des églises, assistez à des événements et faites du bénévolat.",
    "guide_pastor_desc": "Gérez la page de votre église, créez des sermons avec la Bible, organisez des événements et supervisez les membres de votre congrégation.",
    "guide_church_desc": "Enregistrez votre ministère pour atteindre un public mondial, recevoir des dîmes et gérer les opérations de l'église.",
    "guide_admin_desc": "Outils de gestion des utilisateurs, des rôles et de la sécurité du contenu au sein de votre organisation ecclésiale.",
    "guide_feat_feed": "Flux",
    "guide_feat_feed_desc": "Publiez des mises à jour, photos et vidéos. Citez des versets bibliques directement.",
    "guide_feat_events": "Événements",
    "guide_feat_events_desc": "Parcourez la carte ou la liste pour trouver des soirées de louange et des rassemblements.",
    "guide_feat_volunteering": "Bénévolat",
    "guide_feat_volunteering_desc": "Demandez de l'aide ou offrez des services dans le Tableau Communautaire.",
    "guide_feat_profile": "Profil",
    "guide_feat_profile_desc": "Personnalisez votre bio, bannière et connectez-vous avec d'autres croyants.",
    "guide_feat_sermon": "Créateur de Sermons",
    "guide_feat_sermon_desc": "Utilisez l'éditeur de texte enrichi avec l'assistance de la Bible pour rédiger et sauvegarder des sermons.",
    "guide_feat_events_church": "Événements d'Église",
    "guide_feat_events_church_desc": "Créez des événements officiels d'église qui apparaissent sur la carte mondiale.",
    "guide_feat_team": "Équipe",
    "guide_feat_team_desc": "Attribuez des rôles aux autres membres du personnel.",
    "guide_feat_registration": "Inscription",
    "guide_feat_registration_desc": "Créez une page vérifiée pour votre ministère.",
    "guide_feat_donations": "Dons",
    "guide_feat_donations_desc": "Recevez des dîmes en toute sécurité via l'intégration Stripe.",
    "guide_feat_causes": "Causes",
    "guide_feat_causes_desc": "Publiez des besoins communautaires (collectes alimentaires, logement) pour mobiliser du soutien.",
    "guide_feat_user_mgmt": "Gestion Utilisateurs",
    "guide_feat_user_mgmt_desc": "Ajoutez ou supprimez des membres de la liste de votre église.",
    "guide_feat_safety": "Sécurité du Contenu",
    "guide_feat_safety_desc": "L'IA signale automatiquement le contenu inapproprié.",
    "guide_feat_settings": "Paramètres",
    "guide_feat_settings_desc": "Gérez les détails de l'église, les chants de louange et les bannières."
  }
};